export default __webpack_public_path__ + "static/deco-306957c90bc34c3d9e01a19d0667683b.png";